import pushToDataLayer from "./pushToDataLayer";
import ecommerceDataTemplate from "./ecommerceDataTemplate";

const addToWishlistEvent = ({
  productId,
  productCode,
  variantId,
  brandName,
  colour,
  title,
  price,
  variants,
  recommendationsRequestId
}) => {
  pushToDataLayer({
    add_to_wishlist: {
      ecommerce: ecommerceDataTemplate({
        productId,
        productCode,
        variantId,
        brand: brandName,
        colour,
        title,
        price,
        variants
      }),
      ...(recommendationsRequestId && {
        source_recommendations_request_id: recommendationsRequestId
      })
    }
  });
};

export default addToWishlistEvent;
